module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('ul', {
    staticClass: "user-info"
  }, [_c('li', [_c('span', {
    staticClass: "left"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.medicalInfo.userName))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "left"
  }, [_vm._v("身份证号码")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm._f("dotted")(_vm.medicalInfo.idcard)))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "left"
  }, [_vm._v("性别")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.medicalInfo.sex))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "left"
  }, [_vm._v("年龄")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.medicalInfo.age))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "left"
  }, [_vm._v("联系电话")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm._f("dotted")(_vm.medicalInfo.phone)))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "left"
  }, [_vm._v("签约机构")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.medicalInfo.hospitalName))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "left"
  }, [_vm._v("团队名称")]), _vm._v(" "), _c('span', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.medicalInfo.doctorGroupName))])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "code-tips"
  }, [_c('h3', [_vm._v("温馨提示")]), _vm._v(" "), _c('p', [_vm._v("\n      请长按二维码关注彭州市家庭医生公众号,快捷发起家庭医生服务.若您有任何签约家庭医生相关的疑问,\n      请您联系“" + _vm._s(_vm.medicalInfo.hospitalName) + "”咨询。电话:" + _vm._s(_vm.medicalInfo.telephone) + "\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/img/gongzonghao.jpg"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ec924efc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/familyDoctor/Signed.vue
// module id = 883
// module chunks = 0